<script>
    import WalletConnect from "./components/WalletConnect.svelte";
    import Modal from "./components/Modal.svelte";
    import {
      ethStore,
      selectedAccount,
      connected,
      web3,
      chainId,
    } from "svelte-web3";
    import {
        poorcatsnftcontract
    } from "./stores/global.js";
    import { onMount } from "svelte";
    import { getContracts, checkNetwork } from "./stores/contracts.js";


    let t;
    $: numCats = null;
    let network = false;

    //TODO: CHANGE ON SALE START
    let saleStarted = true;

    onMount(async () => {
        if (saleStarted) {
            await ethStore.setBrowserProvider();
            if($web3) {
                await getContracts($web3, $chainId);
            }
            t = $poorcatsnftcontract ? $poorcatsnftcontract.methods.tokenCounter().call() : null;
        }
    })

    $: balance = $connected ? $web3.eth.getBalance($selectedAccount) : "";

    const mint = (async () => {
        const price = 0;
        $poorcatsnftcontract.methods
            .mint(numCats)
            .send({
                from: $selectedAccount,
                value: price.toString()
            })
            .on("sent", function (e) {
                console.log(e);
            })
            .on("receipt", function (e) {
                console.log(e);
            })
            .on("error", function (e) {
                console.log(e);
            })

    });

    function max5() {
        numCats = this.value <= 0 ? 1 : this.value > 5 ? 5 : this.value;
    }
</script>
  
<main>
    <div class="title">
        <h1 class="blurry-text">Poor Cats NFT</h1>
        <h3>cool cats...but for the poor</h3>
        <h3>free mint</h3>
    </div>
    <div class="wallet">
        {#if saleStarted}
            {#if $connected}
                <!-- TODO: CHANGE TO 1 ON DEPLOY -->
                {#if $chainId != 1}
                    <p>Connect to Mainnet</p>
                {:else}
                    <p>connected to: {$selectedAccount.slice(0, 5) + "..." + $selectedAccount.slice(39, 42)}</p>
                    <br>
                    <p class="regular">
                        number of cats to mint:
                        <input
                        class="input"
                        type="number"
                        min="0"
                        max="20"
                        bind:value={numCats}
                        on:input={max5}
                        />
                        max 5 per address
                    </p>
                    <button class="button" on:click={mint}>Mint</button>
                    <br>
                    <p>cats remaining: {#await t then value}{9933-value}{/await}</p>
                {/if}
            {:else}
                <WalletConnect />
            {/if}
            <div class="links">
                <p><a href="https://twitter.com/poorcatsnft" target="_blank">twitter</a> | <a href="https://discord.gg/BYst9pQUDZ" target="_blank">discord</a> | <a href="https://opensea.io/collection/poor-cats-nft" target="_blank">opensea</a> | <a href="https://etherscan.io/address/0x671b758BFeCE08a0957B2273f3759D61edea0f09" target="_blank">etherscan</a></p>
            </div>
        {:else}
            <p>launching sunday, october 10th @ 9 pm est</p>
            <div class="links">
                <p><a href="https://twitter.com/poorcatsnft" target="_blank">twitter</a> | <a href="https://discord.gg/BYst9pQUDZ" target="_blank">discord</a></p>
            </div>
        {/if}
    </div>
    <div class="bottom">
        <p>just developer things - not associated with cool cats</p>
    </div>
</main>


<style>
    .links {
        margin-top: 20px;
        /* padding-top: 20px; */
        /* display: grid; */
    }

    .blurry-text {
        color: black;
        /* text-shadow: 0 0 5px rgba(0,0,0,0.5); */
        filter: blur(3px);
    }

    .bottom {
        position: fixed;
        bottom: 0;
        padding-bottom: 15px;
        font-weight: 300;
        font-style: italic;
        font-size: 0.5em;
    }

    main {
        text-align: center;
        padding: 0;
        max-width: 240px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        place-items: center;
        height: 100vh;
        justify-content: center;
    }

    h1 {
        color: black;
        text-transform: uppercase;
        font-size: 3em;
        font-weight: 200;
        padding-bottom: 0.65rem;
    }

    h3{
        font-weight: 300;
        padding-bottom: 0.5rem;
    }

    .wallet {
        font-weight: 300;
        margin-top: 20px;
    }

    input[type="number"] {
        /* -webkit-appearance: none;
        -moz-appearance: textfield;
        appearance: textfield; */
        width: 50px;
        /* background: var(--secondary-color); */
        border: 1px solid var(--tertiary-color);
        border-radius: 5px;
        /* color: white; */
        text-align: center;
    }
    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }
</style>